import React from "react";

export function TagsIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.90208 2.17641C5.72966 2.22804 4.76282 2.98303 4.4189 3.99997C4.92987 3.92525 5.45209 3.91663 5.97077 3.97725C6.2088 3.69989 6.5625 3.51675 6.96456 3.49904L10.9082 3.32539C11.2716 3.30939 11.6266 3.43339 11.8952 3.67012L21.0448 11.733C21.5013 12.1353 21.6025 12.7426 21.3272 13.192L21.3216 13.2011C21.6396 13.6816 21.8364 14.225 21.9013 14.7853C22.1135 14.4857 22.3158 14.1791 22.5076 13.866C23.152 12.814 22.8473 11.5287 21.9693 10.7551L12.8198 2.69222C12.2825 2.21876 11.5724 1.97075 10.8457 2.00275L6.90208 2.17641ZM2.85214 7.3935C2.85214 5.86255 4.13763 4.62146 5.72337 4.62146H9.85603C10.6175 4.62146 11.3478 4.91351 11.8863 5.43337L21.0561 14.2865C21.936 15.1359 22.1912 16.494 21.4653 17.5644C20.1076 19.5667 18.3321 21.2808 16.2582 22.5917C15.1495 23.2924 13.7428 23.0461 12.8629 22.1966L3.6931 13.3435C3.15464 12.8237 2.85214 12.1186 2.85214 11.3834V7.3935ZM5.72337 6.00748C4.9305 6.00748 4.28775 6.62802 4.28775 7.3935V11.3834C4.28775 11.751 4.43901 12.1035 4.70823 12.3635L13.8781 21.2166C14.3356 21.6582 14.9982 21.7314 15.4719 21.4321C17.3804 20.2257 19.0147 18.6479 20.2642 16.8052C20.5743 16.348 20.4985 15.7082 20.041 15.2665L10.8712 6.41344C10.6019 6.15351 10.2368 6.00748 9.85603 6.00748H5.72337ZM8.35532 8.54852C8.35532 9.314 7.71258 9.93454 6.91971 9.93454C6.12684 9.93454 5.4841 9.314 5.4841 8.54852C5.4841 7.78304 6.12684 7.1625 6.91971 7.1625C7.71258 7.1625 8.35532 7.78304 8.35532 8.54852Z"
        fill="currentColor"
      />
    </svg>
  );
}
